<template>
  <div class="dialog">
    <div class="card">
      <h1>Add Device</h1>

      <DeviceForm
        @hide-dialog="$emit('hide-device-form')"
        @save-device="saveDevice"
      />
    </div>
  </div>
</template>

<script>
import DeviceForm from './DeviceForm';
import firebase from 'firebase/app'
import 'firebase/database'

export default {
  name: "NewDevice",
  components: {
    DeviceForm
  },
  methods: {
    saveDevice(device) {
      firebase.database().ref('devices').push(device)
        .then(() => this.$emit('hide-device-form'))
    }
  }
}
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
@import '../../assets/styles/colors';
@import '../../assets/styles/mixin';
@import '../../assets/styles/dialog';
@import '../../assets/styles/card';
</style>



// WEBPACK FOOTER //
// src/components/device/NewDevice.vue